export default __webpack_public_path__ + "static/media/a037-3.ce216099.svg";